import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Custom hook for consistent navigation throughout the application
 * Centralizes all navigation logic in one place
 */
const useNavigation = () => {
  const navigate = useNavigate();
  
  /**
   * Handle navigation to content (movie or series)
   * @param {string} contentId - The ID or slug of the content
   * @param {string} contentType - The type of content ('movie' or 'series')
   */
  const handleContentSelect = React.useCallback((contentId, contentType) => {
    // Extract slug if full path is provided
    const slug = typeof contentId === 'string' && contentId.startsWith('/channel/') 
      ? contentId.replace('/channel/', '') 
      : contentId;
      
    // Navigate to the content page with the appropriate URL
    navigate(`/channel/${slug}`, { 
      state: { contentType, from: window.location.pathname }
    });
  }, [navigate]);
  
  /**
   * Handle navigation to category page
   * @param {string} categoryId - The ID of the category
   */
  const handleCategorySelect = React.useCallback((categoryId) => {
    navigate(`/category/${categoryId}`);
  }, [navigate]);
  
  /**
   * Navigate back to previous page
   */
  const handleBack = React.useCallback(() => {
    navigate(-1);
  }, [navigate]);
  
  /**
   * Navigate to home page
   */
  const handleHome = React.useCallback(() => {
    navigate('/');
  }, [navigate]);
  
  return {
    handleContentSelect,
    handleCategorySelect,
    handleBack,
    handleHome
  };
};

export { useNavigation };
